var map = {
	"./announcement.png": 75673,
	"./ask_bg.jpg": 6015,
	"./banner-radian.png": 99538,
	"./close.png": 37074,
	"./default_banner.jpg": 54462,
	"./help/help.png": 56210,
	"./home-entry-oa-style/hotel.png": 78985,
	"./home-entry-oa-style/inter-hotel.png": 41791,
	"./home-entry-oa-style/inter-plane.png": 23928,
	"./home-entry-oa-style/oa-bg.png": 19427,
	"./home-entry-oa-style/plane.png": 61235,
	"./home-entry-oa-style/train.png": 61921,
	"./home_welcome_bg.png": 78695,
	"./icon-notice.png": 67160,
	"./icons_24pt_position_O300.svg": 24514,
	"./icons_32pt_flight.svg": 97120,
	"./icons_32pt_notifaction@3x.png": 20222,
	"./icons_40pt_Air_tickets@3x.png": 43861,
	"./icons_40pt_car@3x.png": 7650,
	"./icons_40pt_hotel@3x.png": 97895,
	"./icons_40pt_train_ticket@3x.png": 59470,
	"./lucky-money/button.png": 91015,
	"./lucky-money/close.png": 55817,
	"./lucky-money/lucky_money_1.png": 42547,
	"./lucky-money/lucky_money_2.png": 11765,
	"./message.png": 34467,
	"./notice.png": 63777,
	"./right.png": 76656,
	"./trip_plane.png": 26949
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 86026;